import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  title?: string
  description?: string
  children: React.ReactNode
  backTo?: string
}

export default function ConfigPageLayout({ title, description, children, backTo = '/global-config' }: Props) {
  return (
    <div className="relative overflow-hidden min-h-screen">
      <div aria-hidden className="absolute inset-0 -z-20 bg-gradient-to-b from-emerald-50 via-white to-white dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-900" />
      <div aria-hidden className="absolute inset-x-0 top-0 -z-30 h-[420px] bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.25),_transparent_65%)]" />
      <div aria-hidden className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_20%_20%,rgba(236,72,153,0.15),transparent_60%),radial-gradient(circle_at_80%_10%,rgba(168,85,247,0.18),transparent_55%)] dark:bg-[radial-gradient(circle_at_15%_20%,rgba(236,72,153,0.12),transparent_55%),radial-gradient(circle_at_85%_15%,rgba(168,85,247,0.15),transparent_50%)]" />

      <div className="relative mx-auto flex max-w-[1400px] flex-col gap-6 px-6 py-6">
        <div className="flex items-center gap-4">
          <Link to={backTo} className="inline-flex items-center gap-2 rounded-full border border-zinc-200/70 bg-white/80 px-4 py-2 text-sm font-medium text-zinc-700 shadow-sm transition hover:bg-zinc-50 dark:border-zinc-800 dark:bg-zinc-900/70 dark:text-zinc-300 dark:hover:bg-zinc-800">
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Retour
          </Link>
        </div>

        {description && <p className="text-sm text-zinc-500 dark:text-zinc-400">{description}</p>}

        {children}
      </div>
    </div>
  )
}
